import { Builder, withChildren } from "@builder.io/react";
import { Flex } from "@faire/web/slate/Layout/Flex";

import { BuilderConfig as FlexConfig } from "./builder-config-deprecated/Flex.builder";
import { withTransformations } from "./withTransformations";

const BuilderLayout = withChildren(
  withTransformations(Flex, FlexConfig.transformations ?? {})
);

export const registerBuilderLayout = () => {
  Builder.registerComponent(BuilderLayout, {
    name: "Layout",
    hideFromInsertMenu: true,
    inputs: [
      {
        name: "align",
        type: "object",
        subFields: [
          {
            name: "mobileAndAbove",
            type: "string",
            enum: [
              "center",
              "stretch",
              "flex-start",
              "flex-end",
              "space-between",
              "unset",
              "baseline",
              "normal",
              "end",
              "start",
              "self-end",
              "self-start",
            ],
          },
          {
            name: "tabletAndAbove",
            type: "string",
            enum: [
              "center",
              "stretch",
              "flex-start",
              "flex-end",
              "space-between",
              "baseline",
              "normal",
              "end",
              "start",
              "self-end",
              "self-start",
            ],
          },
          {
            name: "desktopAndAbove",
            type: "string",
            enum: [
              "center",
              "stretch",
              "flex-start",
              "flex-end",
              "space-between",
              "baseline",
              "normal",
              "end",
              "start",
              "self-end",
              "self-start",
            ],
          },
          {
            name: "xLargeAndAbove",
            type: "string",
            enum: [
              "center",
              "stretch",
              "flex-start",
              "flex-end",
              "space-between",
              "baseline",
              "normal",
              "end",
              "start",
              "self-end",
              "self-start",
            ],
          },
          {
            name: "xxLargeDesktop",
            type: "string",
            enum: [
              "center",
              "stretch",
              "flex-start",
              "flex-end",
              "space-between",
              "baseline",
              "normal",
              "end",
              "start",
              "self-end",
              "self-start",
            ],
          },
        ],
      },
      {
        name: "justify",
        type: "object",
        subFields: [
          {
            name: "mobileAndAbove",
            type: "string",
            enum: [
              "center",
              "stretch",
              "flex-start",
              "flex-end",
              "space-between",
              "left",
              "normal",
              "right",
              "space-around",
              "space-evenly",
              "end",
              "start",
            ],
          },
          {
            name: "tabletAndAbove",
            type: "string",
            enum: [
              "center",
              "stretch",
              "flex-start",
              "flex-end",
              "space-between",
              "left",
              "normal",
              "right",
              "space-around",
              "space-evenly",
              "end",
              "start",
            ],
          },
          {
            name: "desktopAndAbove",
            type: "string",
            enum: [
              "center",
              "stretch",
              "flex-start",
              "flex-end",
              "space-between",
              "left",
              "normal",
              "right",
              "space-around",
              "space-evenly",
              "end",
              "start",
            ],
          },
          {
            name: "xLargeAndAbove",
            type: "string",
            enum: [
              "center",
              "stretch",
              "flex-start",
              "flex-end",
              "space-between",
              "left",
              "normal",
              "right",
              "space-around",
              "space-evenly",
              "end",
              "start",
            ],
          },
          {
            name: "xxLargeDesktop",
            type: "string",
            enum: [
              "center",
              "stretch",
              "flex-start",
              "flex-end",
              "space-between",
              "left",
              "normal",
              "right",
              "space-around",
              "space-evenly",
              "end",
              "start",
            ],
          },
        ],
      },
      {
        name: "direction",
        type: "object",
        subFields: [
          {
            name: "mobileAndAbove",
            type: "string",
            enum: ["row", "row-reverse", "column", "column-reverse"],
          },
          {
            name: "tabletAndAbove",
            type: "string",
            enum: ["row", "row-reverse", "column", "column-reverse"],
          },
          {
            name: "desktopAndAbove",
            type: "string",
            enum: ["row", "row-reverse", "column", "column-reverse"],
          },
          {
            name: "xLargeAndAbove",
            type: "string",
            enum: ["row", "row-reverse", "column", "column-reverse"],
          },
          {
            name: "xxLargeDesktop",
            type: "string",
            enum: ["row", "row-reverse", "column", "column-reverse"],
          },
        ],
      },
      {
        name: "gap",
        type: "object",
        subFields: [
          {
            name: "mobileAndAbove",
            type: "number",
          },
          {
            name: "tabletAndAbove",
            type: "number",
          },
          {
            name: "desktopAndAbove",
            type: "number",
          },
          {
            name: "xLargeAndAbove",
            type: "number",
          },
          {
            name: "xxLargeDesktop",
            type: "number",
          },
        ],
      },
    ],
  });
};
